import React from "react"
import Form from "../../../../utils/Form"
import { iGDM_CALC_STRUCTURE } from "../Structure"

interface iCalculatorForm {
  initData: { [id: string]: any }
  onSubmit: (data: any) => void
  onChange: (data: {
    data: any
    recentUpdate: { key: string; value: any }
  }) => void
  calculatorStructure: iGDM_CALC_STRUCTURE
}

const CalculatorForm: React.FC<iCalculatorForm> = ({
  initData,
  onSubmit,
  calculatorStructure,
  onChange,
}) => {
  return (
    <Form data={initData} onSubmit={onSubmit} onChange={onChange}>
      {(data, setData) => (
        <>
          {Object.keys(calculatorStructure).map(
            (item: string, index: number) => {
              const INPUT = calculatorStructure[item]
              const variable_name = item
              return (
                <div key={`div-${index}`} id={variable_name}>
                  <INPUT.Component
                    key={index}
                    {...INPUT}
                    onChange={(e: any) =>
                      setData(variable_name, e.target.value.toString())
                    }
                    disable={false}
                    error={
                      INPUT.error ? INPUT.error(data[variable_name]) : null
                    }
                    warning={
                      INPUT.warning ? INPUT.warning(data[variable_name]) : null
                    }
                    value={data[variable_name]}
                  />
                </div>
              )
            }
          )}
        </>
      )}
    </Form>
  )
}

export default CalculatorForm
